import React, { useEffect, useState } from 'react';
import { UserManagementImage } from '../../../assets/images';
import {
  CommonHeader,
  ContentArea,
  EmptyListPage,
  ErrorSuccessModal,
  Loader
} from '../../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { getAllFinacUsersAction, resetFinacUsersList, resetSession } from '../../../redux/auth';
import { getAllUserGroupsAction, resetUserManagementError, resetUserManagementSuccess } from '../../../redux/userManagement';
import { UserGrouptype } from '../../../redux/userManagement/userManagementTypes';
import {  UserGroupTable } from '../../../components/UserManagement';
import { USER_GROUP_LIST_HEADERS } from '../../../constant/tableHeadersConstants/userManagementConstants/userGroupListConst';
import { Link } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { GetAllFinacUserPayloadType} from '../../../commonTypes/authTypes';
import { GetAllUserGroupPayloadType } from '../../../commonTypes/userManagementTypes';

type AppProps = {
  token: string | null;
  finacUsersList: any;
  success: number | null;
  fetching: boolean;
  error: string | null;
  statusCode: number | null;
  history?: any;
  userGroupList: [] | UserGrouptype[];
  dispatchResetSession: () => void;
  dispatchResetUserManagementError: () => void;
  dispatchResetUserManagementSuccess: () => void;
  dispatchResetFinacUsersList: () => void;
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => void,
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void | undefined;
}

const UserGroups = ({
  token,
  finacUsersList,
  history,
  success,
  userGroupList,
  statusCode,
  error,
  fetching,
  dispatchResetSession,
  dispatchGetAllUserGroupsAction,
  dispatchResetUserManagementError,
  dispatchResetUserManagementSuccess,
  dispatchGetAllFinacUsersAction,
  dispatchResetFinacUsersList
}: AppProps) => {
  const [successMessage, setSuccessMessage] = useState<string>('');
  //========== User Management ==========//
	const [isAddUserGroupsPresent, setIsAddUserGroupsPresent] = useMenuCheck();
	const [isEditUserGroupsPresent, setIsEditUserGroupsPresent] = useMenuCheck();
  //====================//
  useEffect(() => {
    dispatchResetUserManagementError();
    dispatchResetUserManagementSuccess();
    dispatchResetFinacUsersList();
    setIsAddUserGroupsPresent("Add User Group","menu")
    setIsEditUserGroupsPresent("Edit User Group","menu")
    if (token) {
      dispatchGetAllUserGroupsAction({token})
      const finalData={
        token,
        user_type:'all',
        status:1
      }
      dispatchGetAllFinacUsersAction(finalData)
    }

  }, []);



  const handleRedirectToEditUserGroup = (menuGroupId: number | undefined) => {
    if (menuGroupId) {
      history.push({
        pathname: `/user-management/user-groups/edit-user-group/${ menuGroupId }`,
      })
    }
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserManagementError();
            }}
          />
        )
      }
    }
    else if (success === 1) {
      dispatchResetUserManagementSuccess()
      toast.success(successMessage, {
        duration: 2000
      });
    }

    return false;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title='User Group'
          />
        </div>
        <div className="col-md-6">
          <div className="d-flex flex-row justify-content-end">
                {isAddUserGroupsPresent && <Link
                  className="btn btn-primary"
                  to={{
                    pathname: "/user-management/user-groups/add-user-group",
                  }}
                >
                  + Add User Group
                </Link>}
          </div>
        </div>
      </div>
      <ContentArea>
        {userGroupList?.length > 0 ?
          <UserGroupTable
            userGroupsList={userGroupList}
            tableHeaders={USER_GROUP_LIST_HEADERS}
            fetching={fetching}
            handleRedirectToEditUserGroup={handleRedirectToEditUserGroup}
            isEditUserGroupsPresent={isEditUserGroupsPresent}
          /> :
          <EmptyListPage
            title="No User Groups Found!"
            text="Create a user group and manage the list here"
            buttonTitle="+ Create User Group"
            showLinkButton
            link={`/user-management/user-groups/add-user-group`}
            image={UserManagementImage}
            imageWidth="30%"
          />

        }

      </ContentArea>
      {handleErrorModal()}
      {fetching && <Loader />}
      <Toaster />
    </>
  )
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  finacUsersList: state.auth.finacUsersList,
  fetching: state.userManagement.fetching,
  success: state.userManagement.success,
  statusCode: state.userManagement.statusCode,
  error: state.userManagement.error,
  userGroupList: state.userManagement.userGroupList
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetUserManagementError: () => dispatch(resetUserManagementError()),
  dispatchResetUserManagementSuccess: () => dispatch(resetUserManagementSuccess()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => dispatch(getAllUserGroupsAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
})

export default connect(mapStateTopProps, mapDispatchToProps)(UserGroups);